import { MoovyDialog } from '../../../components'

import { UseMutationResult } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { FormattedMessage } from 'react-intl'
import { ParkingEventDetailsDTO } from '../../../apis/parkingEvents/dto'
import testidKeys from '../../../app/testidKeys'
import FormEditFee, { OnSubmitCallback } from './formEditFee'

export type ModalEditFeeProps = {
  isOpen: boolean
  parkingDetails: ParkingEventDetailsDTO
  mutation: UseMutationResult<AxiosResponse<any, any>, unknown, any, unknown>
  errorTitleKey: string
  invalidationOnly: boolean
  onSubmit: OnSubmitCallback
  onCancel: () => void
}

const FORM_REFERENCE = 'formEditFee'

const ModalEditFee = (props: ModalEditFeeProps) => {
  return (
    <MoovyDialog
      open={props.isOpen}
      onCancel={props.onCancel}
      formReference={FORM_REFERENCE}
      errorTitleKey={props.errorTitleKey}
      modalTitle={
        <FormattedMessage id="page.parkingDetails.modalEditFee.title" />
      }
      submitButtonContent={
        <FormattedMessage id="page.parkingDetails.formEditFee.submit" />
      }
      mutation={props.mutation}
      data-testid={testidKeys.SUMMARY_EDIT_FEE_MODAL}
    >
      <FormEditFee
        formReference={FORM_REFERENCE}
        parkingDetails={props.parkingDetails}
        onSubmit={props.onSubmit}
        invalidationOnly={props.invalidationOnly}
      />
    </MoovyDialog>
  )
}

export default ModalEditFee
